import React, { Component,useState,useEffect } from "react";
import { Button,Modal,Form,Card  } from 'react-bootstrap';

import ErrorTokenMiss from "../ErrorTokenMiss/ErrorTokenMiss";
import LoadingOverlay from "react-loading-overlay";
import RequestManager from "../../singletons/RequestManager";

export default function InventoryPrice(props) {
    const [price, setPrice] = useState(props.checkstock == true ? props.stock.mrp : props.forstockdetails.price);
    const [salePrice, setSalePrice] = useState(props.checkstock == true ?props.stock.sale_price : props.forstockdetails.salePrice);
    const [description, setDescription] = useState("");
    const [comments, setComments] = useState("");
    const [spinnerLoading, setSpinnerLoading] = useState(false);

    var stock=props.stock

    // useEffect(() => {
  
    //   setSalePrice(props.checkstock == true ? props.stock.mrp : props.forstockdetails.price)
    //   setPrice(props.checkstock == true ? props.stock.mrp : props.forstockdetails.price)
    
    // }, [props]);

  

   const updatePrice = async () => {
     console.log("call update")
       setSpinnerLoading( true );
      let requestManager = new RequestManager();
      let stock = props.stock;
       console.log(stock,"stock")
      // let sale = 0;
      console.log(salePrice)

      let params = {
        input: {
          id: stock.stock_id,
          settlementPrice:salePrice.length > 0 ? parseFloat(salePrice) : parseFloat(price),
          price: parseFloat(price),
          salePrice:salePrice.length > 0 ? parseFloat(salePrice) : parseFloat(price),
        },
      };
  
      console.log("paramss", JSON.stringify(params));
      let response = await requestManager.getResponseFromPredefinedQuery(
        "updateStock",
        params
      );
      console.log(response.error)
      if (response.error === null) {
        updateSkuPrice();
        console.log(response,"updateStock")
        // console.log("updateStock", JSON.stringify(response));
        window.location.reload(false)
      } else {
         setSpinnerLoading( false );
        //  window.location.reload(false)
        console.log(
          "Unable to update inventory. Please check your internet connection."
        );
      }
    };

   const updateSkuPrice = async () => {
    setSpinnerLoading( true );
      let requestManager = new RequestManager();
      let stock = props.stock;
      let params = {
        input: {
          id: stock.sku_id,
          description: description,
          maximumRetailPrice: parseFloat(price),
        },
      };
      console.log(
        "name",
        JSON.stringify(
          stock.category_name +
            " - " +
            stock.sku_name +
            " - " +
            stock.quantity
        )
      );
      console.log("params", JSON.stringify(params));
      let response = await requestManager.getResponseFromPredefinedQuery(
        "updateSku",
        params
      );
      // console.log(response.error)
      if (response.error === null) {
         setSpinnerLoading(false);
        console.log("updateSku", response);
        
      } else {
         setSpinnerLoading(false);
         window.location.reload(false)
        console.log(
          "Unable to update inventory. Please check your internet connection."
        );
      }
    };

    return (
        <LoadingOverlay
      style={{ width: "100%", height: "100%", zIndex: 999 }}
      active={spinnerLoading === true ? true : false}
      spinner
      text="Loading ..."
    >
        <Form>
            <Form.Group controlId="formBasicEmail">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" placeholder="Name" disabled defaultValue={
                        stock.quantity === null
                          ? stock.category_name +
                            " - " +
                            stock.sku_name
                          : stock.category_name +
                            " - " +
                            stock.sku_name +
                            " - " +
                            stock.quantity
                      }  />
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
                <Form.Label>Product Price:{price}</Form.Label>
                <Form.Control type="text" placeholder="Product Price ₹" defaultValue={price}  onChange={(e) => setPrice(e.target.value)} />
            </Form.Group>

            <Form.Group controlId="formBasicEmail">
                <Form.Label>Discounted Price: {salePrice}</Form.Label>
                <Form.Control type="text" placeholder="Discounted Price ₹" defaultValue={salePrice}  onChange={(e) => setSalePrice(e.target.value)} />
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
                <Form.Label>Description:{description}</Form.Label>
                <Form.Control type="text" placeholder="Description"  onChange={(e) => setDescription(e.target.value)} />
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
                <Form.Label>Comments:{comments}</Form.Label>
                <Form.Control type="text" placeholder="Comments"  onChange={(e) => setComments(e.target.value)} />
            </Form.Group>

            <Button
                  
                    style={{
                      backgroundColor: "#ff5500",
                      color: "white",
                      padding: 10,
                    }}
                    onClick={() => {
                      updatePrice("price");
                      // if (price.length > 0) {
                      //   this.updatePrice("price");
                      // } else {
                      //   this.toggleErrorTokenMissModal("Enter valid price");
                      // }
                    }}
                  >
                    {"Save"}
                  </Button>
        </Form>
        </LoadingOverlay>

    );
}


// WEBPACK FOOTER //
// ./src/components/InventoryPrice/InventoryPrice.js